module.exports = __webpack_public_path__ + "static/media/slide1.44d1fbc8.png";